import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import Column from 'components/ui/show/Column';
import EditButton from 'components/button/EditButton';
import Header from 'components/ui/general/Header';
import InnerColumn from 'components/ui/show/InnerColumn';
import ListButton from 'components/button/ListButton';
import LoadingCard from 'components/loading/LoadingCard';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';
import Section from 'components/ui/general/Section';
import SubcategoriesShow from './SubcategoriesShow';
import Title from 'components/ui/general/Title';
import compose from 'recompose/compose';
import fetchResourceAndLocalisationById from 'components/hoc/fetchResourceAndLocalisationById';
import translate from 'components/hoc/translate';
import { fetchSubcategory } from 'store/actions/subcategories/fetchSubcategories';

class SubcategoriesShowContainer extends React.Component {
    render() {
        const {
            data,
            localisation,
            resourceFetchFailed,
            resourceFetchLoading,
            translate,
        } = this.props;

        if (resourceFetchLoading) {
            return <LoadingCard />;
        }

        if (resourceFetchFailed) {
            return <ResourceNotFound />;
        }

        const breadcrumbs = [
            {
                label: translate('resources.subcategories.title'),
                link: `/subcategories`,
            },
            {
                label: data.name,
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('resources.subcategories.actions.show', { title: data.name }) } />

                    <Actions>
                        <EditButton url={ `/subcategories/${ data.id }` } />

                        <ListButton url='/subcategories' />
                    </Actions>
                </Header>

                <Section>
                    <Column size={ 12 }>
                        <InnerColumn>
                            <SubcategoriesShow
                                data={ data }
                                localisation={ localisation }
                            />
                        </InnerColumn>
                    </Column>
                </Section>
            </div>
        );
    }
}

SubcategoriesShowContainer.contextTypes = {
    config: PropTypes.object,
};

SubcategoriesShowContainer.propTypes = {
    data: PropTypes.object,
    id: PropTypes.number.isRequired,
    localisation: PropTypes.object,
    resourceFetchFailed: PropTypes.bool.isRequired,
    resourceFetchLoading: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
};

const enhance = compose(
    translate,
    fetchResourceAndLocalisationById({
        action: fetchSubcategory,
        resource: 'subcategories',
    })
);

export default enhance(SubcategoriesShowContainer);



// WEBPACK FOOTER //
// ./src/pages/subcategories/show/SubcategoriesShowContainer.js